<template>
  <div v-if="errors.length > 0" :class="errorClasses">
    <p v-for="message in errors" :key="message">
      {{ message }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    errors: {
      type: Array,
      default: [],
    },
    errorClasses: {
      type: String,
      default: 'text-red-400 my-2',
    },
  },
};
</script>
